import React ,{ useState }from "react";

import { Bounce } from 'react-activity';
import 'react-activity/dist/react-activity.css';

import Drawer from '@material-ui/core/Drawer';

import { getOrderStatus,getMenus,getOrders,getScreenFields,updateNoti,getSettings,getMaster,getJobStatus,getPatientRights,getAccounts ,getDpExport} from "../../crud/auth.crud";
import { Link } from "react-router-dom";
import { IconButton,TextField,MenuItem,InputLabel,Select } from '@material-ui/core';
import { Tooltip } from "@material-ui/core";	
//import InfiniteScroll from "react-infinite-scroller";
import SearchIcon from '@material-ui/icons/Search';
import DateFnsUtils from '@date-io/date-fns';
import {  format } from 'date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import Grid from '@material-ui/core/Grid';					
import EditIcon from '@material-ui/icons/Edit';		
import Checkbox from '@material-ui/core/Checkbox';
//import PaymentIcon from '@material-ui/icons/Payment';
import DescriptionIcon from '@material-ui/icons/Description';
import ReceiptIcon from '@material-ui/icons/Receipt';

import Button from '@material-ui/core/Button';
//import SaveIcon from '@material-ui/icons/Save';
import Icon from '@material-ui/core/Icon';
 import CodeExample from "../../partials/content/CodeExample";
//import setDisplay from "../../partials/content/CodeExample";
import EditOrderReqStatus from './EditOrderReqStatus'

 import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
//import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
 
import Autocomplete from '@material-ui/lab/Autocomplete';
//import { ThreeDRotationSharp, TrendingUpOutlined } from "@material-ui/icons";
import EditOrderInvoice from "../../widgets/EditOrderInvoice";
import OrderPayment from "../../widgets/OrderPayment";
import Chip from '@material-ui/core/Chip';
import { NavigateBeforeSharp } from "@material-ui/icons";
import StagedOrder from "../../widgets/StagedOrder";
//import { update } from "lodash";


//import Moment from 'moment';
 

export default class Orders extends React.Component {
 
  handleDateChange = (date) => {
    this.setState({selectedDate : date});
  };

  state = {
    schedules:[],
    pRights:[],
    hasMoreItems:false,
    page:1,
        isReset:false,

    isLoading:false,
        filterFields :{},
    fields:[],
    filter:false,
    selectedDate:null,
    open:false,
    notes:[],
    notesId:'',
    statusSettings:
        "JOBS00003"
    ,
    postObj:{},
	statusFilter:null,
	selectedDrawerItem:null,
	invoiceDrawerOpen:false,
	invoiceViewDrawerOpen:false,
	jobServiceTypes:[],
	permission:[],
	stagedDrawerViewOpen:false,
	implants:[],
  }

 constructor(props)
{
	super(props);


}

getImplantName(id) {
  return this.state.implants
    .filter(x => x.implantTypeKey === id)
    .map(x => x.implantName);
}


handleCloseInvoiceDrawer()
{
	this.setState({invoiceDrawerOpen:false});
}


handleCloseInvoiceViewDrawer()
{
	this.setState({invoiceDrawerViewOpen:false});
}

handleOpenInvoiceDrawer(jobRequest)
{
	this.setState({invoiceDrawerOpen:true,selectedDrawerItem:jobRequest});
}

handleOpenStagedDrawer(jobRequest)
{
	this.setState({stagedDrawerViewOpen:true,selectedDrawerItem:jobRequest});
}

handleOpenInvoiceViewDrawer(jobRequest)
{
	this.setState({invoiceDrawerViewOpen:true,selectedDrawerItem:jobRequest});
}

toggleInvoiceDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    this.setState({invoiceDrawerOpen:false})
  };


  toggleStagedDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    this.setState({stagedDrawerViewOpen:false})
  };

  
toggleInvoiceViewDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    this.setState({invoiceDrawerViewOpen:false})
  };


resetFilter()
{
	let postObj={};
  		//this.state.filter=false;
  		  		this.setState({isReset:false});
  		  		
  		  		this.setState({filter:false},function(){
					this.setState({filter:true})		
  		  		})
				
  		  		
  	 	this.state.fields[0].fields.map((field)=> {
  			
  			this.state[`Filter_${field.fieldName}`]=null;

 
  			})
}

	reserFilterText()
	{
		this.setState({filter:true})
	}

   handleReset(event)
  {
  		let postObj={};
  		//this.state.filter=false;
  		  		this.setState({isReset:true});
  		  		
  		  		this.setState({filter:false},function(){
					this.setState({filter:true})		
  		  		})
				
  		  		
  	 	this.state.fields[0].fields.map((field)=> {
  			
  			this.state[`Filter_${field.fieldName}`]=null;
			if(field.dataType==='autocomplete')
			{
				this.setState({[field.fieldName]:[],[`Filter_${field.fieldName}`]:''});
				
			}
 
  			})

  			this.setState({activePage:1})
			  getOrders(1,{})//.then(response => response.data)
			    .then((response) => {

			
  		  			 		
			        this.setState({ schedules: response.data });
			        this.setState({isLoading:false})
			      	if(parseInt(response.headers["x-total-records"])>this.state.schedules.length)
			      		this.setState({hasMoreItems:true})
			      	else
			      		this.setState({hasMoreItems:false})
			      	  		this.setState({isReset:false});

	     });	
  }

async componentWillReceiveProps(nextProps)
{
  let postObj={};
      
    if(this.props.location.data!==null && this.props.location.data!==undefined)
    {
    console.log(":::::props from dashboard::::::",this.props.location.data);
    postObj=this.props.location.data;
	//console.log("statuskeu props from dashboard:::",this.props.location.data.statusKey);
	if(this.props.location.data.orderStatusKey!==null && this.props.location.data.orderStatusKey!==undefined)
	{
		this.setState({statusFilter:this.props.location.data.orderStatusKey});
	}
	if(this.props.location.data.accountKey===null)
	{
		delete postObj.accountKey;
		postObj = postObj;
	}
   }

   if(this.props.location.notification!==null && this.props.location.notification!==undefined)
    {
    //console.log(":::::props from header notification::::::",this.props.location.notification);
    let notification = this.props.location.notification.noti;
    //postObj=this.props.location.data;
    let notiObj = {
      isActive:false,
      isDeleted:true
    }
    updateNoti(notification.id,notiObj)
    .then((response)=>
    {
      //console.log(response);
    });
   }


   getOrders(1,postObj)//.then(response => response.data)
    .then((response) => {
      this.setState({isLoading:false})
      this.setState({ schedules: response.data,postObj:postObj})
      this.setState({totalCount:response.headers["x-total-records"]});
      if(parseInt(response.headers["x-total-records"])>response.data.length)
        this.setState({hasMoreItems:true,isLoading:false})
      //console.log(this.state.users)
     })
}

  loadMore(){

  	let postObj={};
	  	//console.log(this.state.fields[0].fields);
	  	this.state.fields[0].fields.map((field)=> {
	  			
	  			if(this.state[`Filter_${field.fieldName}`]!=undefined && this.state[`Filter_${field.fieldName}`]!='')
	  			{
	  				 if(field.dataType==="lookup")
	  				 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
					 else if(field.dataType==="autocomplete")
					 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
	  				 else if (field.dataType==="date")
	  				 {
	  				 	//alert(field.fieldName+' : '+this.state[`Filter_${field.fieldName}`]);
	  				 	let varSelectedDate=this.state[`Filter_${field.fieldName}`]
	  				 	let formattedDate=format(varSelectedDate, 'yyyy-MM-dd')
	  				 	//const formattedDate = varSelectedDate.getFullYear()+'-'+(varSelectedDate.getMonth()+1)+'-'
	  				 	//+varSelectedDate.getDate();
	  				 	//alert(formattedDate);
	  				 	postObj[field.fieldName]=formattedDate;
	  				 }
	  				 else
	  				 {
	  				 	
	  				 	postObj[field.fieldName]=this.state[`Filter_${field.fieldName}`];
	  				 }
	  			}

	  			})
	if(this.state.statusFilter!==null)
	{
		postObj['orderStatusKey'] = this.state.statusFilter;
	}

  	this.setState({isLoading:true})
    
  		this.setState({page:this.state.page+1},()=>
  	{
     getOrders(this.state.page,postObj)//.then(response => response.data)
  	
    .then((response) => 
    {
      this.setState({ schedules:this.state.schedules.concat(response.data) }
      ,()=>{
      	this.setState({isLoading:false})
      	if(parseInt(response.headers["x-total-records"])>this.state.schedules.length)
      	this.setState({hasMoreItems:true})
      	else
      		this.setState({hasMoreItems:false})
      	

      });
     })
	});


   
  }



  updateStatus=(jobr)=>
  {

	let jobRequests = this.state.schedules;
	let index = jobRequests.findIndex(x=>x.jobRequestKey===jobr.jobRequestKey);
	jobRequests[index].jobStatusId = jobr.jobStatusId;
	this.setState({ schedules: jobRequests,open:false});

  }
  
  componentDidMount()
  {
 
  	//get status

  	getOrderStatus().then(response => response.data)
    .then((data) => {
      this.setState({ mStatus: data })
     // console.log(data);
     });

	

	 getMenus().then(response => response.data)
		 .then((data) => {
		   
		   if(data[0] != null && data[0].permissions !=null)
					 {
					  
					   console.log(data[0].permissions);
					   let perms="";
					   data[0].permissions.map((per) =>(
						 perms = perms + "," + per
						 ))
					   console.log(perms);
						this.setState({ permission: perms })
	 
					 }
		  });

	getMaster("settings").then(response => response.data)
    .then((data) => {
		data.filter(x=>x.settingsId==="orderstatus").map((stt)=>{
			this.setState({ statusSettings: stt.data.complete })
			//console.log("statusSettings",stt.data.complete);
		
		})
			
		  getMaster("implant").then(response => response.data)
							.then((data) => {
							 this.setState({ implants:data});
							  //console.log(this.state.users)
							 })
		
		
      
      //console.log("statusSettings::::",data);
     });

    getAccounts().then(response => response.data)
      .then((data) => {
        this.setState({ mAccounts: data })
       // console.log(data);
       });


  	this.setState({hasMoreItems:false,isLoading:true});
  	getScreenFields('order')
  	.then((fieldResponse) => {
  		this.setState({fields:fieldResponse.data});

  		//console.log("fieldResponse",fieldResponse.data)
  		
  		let filterLength=fieldResponse.data[0].fields
  			.filter((fieldFilter) => fieldFilter.dataType==='lookup' || fieldFilter.dataType==='autocomplete').length;
  		//alert('loop length : '+filterLength );

  		let loopCounter =0;
  		fieldResponse.data[0].fields
  			.filter((fieldFilter) => fieldFilter.dataType==='lookup' || fieldFilter.dataType==='autocomplete')
  			.map((fieldMap)=>
  					{
  							if(fieldMap.dataType.includes('autocomplete'))
							{
								console.log("datata",fieldMap.dataType);
								this.setState({[fieldMap.fieldName]:[]});
								loopCounter++;
								if(loopCounter===filterLength)
									this.setState({filter:true});

							}
							else if(fieldMap.dataType.includes('lookup'))
							{
								console.log("datata",fieldMap.dataType);
								getMaster(fieldMap.lookUp.lookupName)
								.then((filterResponse)=>
									{
										//console.log('Master :',fieldMap.fieldName);
										//alert(fieldMap.fieldName);
										this.setState({[fieldMap.fieldName]:filterResponse.data});
										loopCounter++;
										if(loopCounter===filterLength)
											this.setState({filter:true});


									})
							}
							
						}
  					
  				)
    });

    let postObj={};
			
  	if(this.props.location.data!==null && this.props.location.data!==undefined)
  	{
		console.log(":::::props from dashboard::::::",this.props.location.data);
		postObj=this.props.location.data;
		if(this.props.location.data.orderStatusKey!==null && this.props.location.data.orderStatusKey!==undefined)
		{
			this.setState({statusFilter:this.props.location.data.orderStatusKey});
		}
		if(this.props.location.data.accountKey===null)
		{
			delete postObj.accountKey;
			postObj = postObj;
		}
	}

  if(this.props.location.notification!==null && this.props.location.notification!==undefined)
    {
    console.log(":::::props from header notification::::::",this.props.location.notification);
    let notification = this.props.location.notification.noti;
    //postObj=this.props.location.data;
    let notiObj = {
      isActive:false,
      isDeleted:true
    }
    updateNoti(notification.id,notiObj)
    .then((response)=>
    {
      console.log(response);
    });
   }


   getOrders(1,postObj)//.then(response => response.data)
    .then((response) => {
    	this.setState({isLoading:false})
      this.setState({ schedules: response.data,postObj:postObj})
      this.setState({totalCount:response.headers["x-total-records"]});
      if(parseInt(response.headers["x-total-records"])>response.data.length)
      	this.setState({hasMoreItems:true,isLoading:false})
      //console.log(this.state.users)
     })


  }

  updateItem(jobr)
  {
	console.log("Update Item:::::", jobr);
	let jobRequests = this.state.schedules;
	let index = jobRequests.findIndex(x=>x.jobRequestKey===jobr.jobRequestKey);
	jobRequests[index].invoiceStatus =true;
	this.setState({ schedules: jobRequests,open:false});
  }

  payment(jobr)
  {
	console.log("payment update");
	console.log("Update Item:::::", jobr);
	let jobRequests = this.state.schedules;
	let index = jobRequests.findIndex(x=>x.jobRequestKey===jobr.jobRequestKey);
	jobRequests[index].paidStatus =true;
	this.setState({ schedules: jobRequests,open:false});
  }

  

   async componentWillReceiveProps(nextProps)
  {
	let postObj={};
		
	  if(this.props.location.data!==null && this.props.location.data!==undefined)
	  {
	  console.log(":::::props from dashboard::::::",this.props.location.data);
	  postObj=this.props.location.data;
	//console.log("statuskeu props from dashboard:::",this.props.location.data.statusKey);
	if(this.props.location.data.orderStatusKey!==null && this.props.location.data.orderStatusKey!==undefined)
	{
		this.setState({statusFilter:this.props.location.data.orderStatusKey});
	}
	if(this.props.location.data.accountKey===null)
	{
		delete postObj.accountId;
		postObj = postObj;
	}
	 }
  
	 if(this.props.location.notification!==null && this.props.location.notification!==undefined)
	  {
	  //console.log(":::::props from header notification::::::",this.props.location.notification);
	  let notification = this.props.location.notification.noti;
	  //postObj=this.props.location.data;
	  let notiObj = {
		isActive:false,
		isDeleted:true
	  }
	  updateNoti(notification.id,notiObj)
	  .then((response)=>
	  {
		//console.log(response);
	  });
	 }
  
  
	 getOrders(1,postObj)//.then(response => response.data)
	  .then((response) => {
		this.setState({isLoading:false})
		this.setState({ schedules: response.data,postObj:postObj})
		this.setState({totalCount:response.headers["x-total-records"]});
		if(parseInt(response.headers["x-total-records"])>response.data.length)
		  this.setState({hasMoreItems:true,isLoading:false})
		//console.log(this.state.users)
	   })
  }
  


handleCloseNew = () =>
  {
  	console.log("close new");
    this.setState({open:false});
    let schedule =  this.state.schedule;
	let postObj = {jobRequestKey:schedule.jobRequestId};
  	//if(this.props.location.data!=null)
  	//{
	//	console.log(":::::props from dashboard::::::",this.props.location.data);
	//	postObj=this.props.location.data;
	//}


	getOrders(1,postObj)//.then(response => response.data)
    .then((response) => {
    	console.log("notes::",response.data.length);
    	if(response.data.length>0)
    	{
			
	    	response.data.map((s) => (
	    		console.log("notes::+",s),
	    		schedule.status = s.status,
	    		schedule.notesCount= s.notesCount,
	    		schedule.notes = s.notes,
	    		schedule.scheduleType = s.scheduleType,
	    		schedule.percentage = s.percentage,
          schedule.startDate = s.startDate,
          schedule.locationKey = s.locationKey,
	    		this.setState({schedules: this.state.schedules.map(el => (el.id === s.id ? {...el, schedule} : el))})	
	        ))
    	}
    	else
    	{
    		console.log("notes::-");
    		schedule.status = 'green';
    		schedule.percentage =100;
    		this.setState({schedules: this.state.schedules.map(el => (el.id === schedule.id ? {...el, schedule} : el))})	
    	}
    	
     })
  }

   handleClose = () =>
  {
    this.setState({open:false});
    let postObj={};
			
  	//if(this.props.location.data!=null)
  	//{
	//	console.log(":::::props from dashboard::::::",this.props.location.data);
	//	postObj=this.props.location.data;
	//}


	getOrders(1,postObj)//.then(response => response.data)
    .then((response) => {
    	this.setState({isLoading:false})
      this.setState({ schedules: response.data})
      this.setState({totalCount:response.headers["x-total-records"]});
      if(parseInt(response.headers["x-total-records"])>response.data.length)
      	this.setState({hasMoreItems:true,isLoading:false})
      //console.log(this.state.users)
     })
  }

filterByStatus= (statusId) => {

  let postObj={};
			
  	this.resetFilter();
    console.log("filterby status:::::",statusId);
    if(statusId !=null && statusId!="")
    {
		postObj={
			orderStatusKey: statusId
		};

		this.setState({statusFilter: statusId});
	}

	getOrders(1,postObj)//.then(response => response.data)
    .then((response) => {
    	this.setState({isLoading:false})
      this.setState({ schedules: response.data,postObj:postObj})
      this.setState({totalCount:response.headers["x-total-records"]});
      if(parseInt(response.headers["x-total-records"])>response.data.length)
      	this.setState({hasMoreItems:true,isLoading:false})
      //console.log(this.state.users)
     });
}

 

    handleFilter(event)
	{
	  	let postObj={};
	  		  	this.setState({isLoading:true});

	  	console.log(this.state.fields[0].fields);
	  	this.state.fields[0].fields.map((field)=> {
	  			
	  			if(this.state[`Filter_${field.fieldName}`]!=undefined && this.state[`Filter_${field.fieldName}`]!='' && field.isDummy ===false)
	  			{
	  				 if(field.dataType==="lookup")
	  				 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
					 else  if(field.dataType==="autocomplete")
					 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
	  				 else if (field.dataType==="date")
	  				 {
	  				 	//alert(field.fieldName+' : '+this.state[`Filter_${field.fieldName}`]);
	  				 	let varSelectedDate=this.state[`Filter_${field.fieldName}`]
	  				 	let formattedDate=format(varSelectedDate, 'yyyy-MM-dd')
	  				 	//const formattedDate = varSelectedDate.getFullYear()+'-'+(varSelectedDate.getMonth()+1)+'-'
	  				 	//+varSelectedDate.getDate();
	  				 	//alert(formattedDate);
	  				 	postObj[field.fieldName]=formattedDate;
	  				 }
					 else if(field.dataType==="dropdown")
	  				 {	  				 	
	  				 	postObj['cdnbool'+field.fieldName]=this.state[`Filter_${field.fieldName}`].toString();
	  				 }
	  				 else
	  				 {
	  				 	
	  				 	postObj[field.fieldName]=this.state[`Filter_${field.fieldName}`];
	  				 }
	  			}

	  			})
	  			this.setState({activePage:1})
	  		   
	  		    getOrders(1,postObj)
					    .then((response) => {
					      this.setState({ schedules: response.data,page:1 , postObj:postObj})
					      this.setState({totalCount:response.headers["x-total-records"]});
					      if(parseInt(response.headers["x-total-records"])>response.data.length)
					      	this.setState({hasMoreItems:true})
					      else
					      	this.setState({hasMoreItems:false})
				this.setState({isLoading:false});					     })
	}

	autocompleteOnChange=(event,newValue,fieldName,lookupKey) => {
		if(event!==null && newValue!==null)
		{
		  console.log("autocomplete change:::",event ,newValue,fieldName,lookupKey,newValue[lookupKey]);
		  this.setState({[fieldName]:newValue[lookupKey]});
		}
		
	  }
	
	  autocompleteOnInputChange=async (event,value,fieldName,lookupKey,lookupName) =>  {
		if(event!==null && value!==null && value.length>3)
		{
		  //console.log("autocomplete input change:::",event ,value,fieldName,lookupKey);
		  //this.setState({[fieldName]:newValue[lookupKey]});
		  var postObj = {
			nameLowerCase: value.toLowerCase()
			
		  };
		  let patientData=[];
		
			await getPatientRights(1,postObj)
			  .then((response) => {
				  response.data.map((p)=>(
					 patientData.push(p)
				  ))
				  this.setState({ [fieldName]:patientData});
		   });
		   /*await getMaster(lookupName)
			.then((filterResponse)=>
			{
				this.setState({[fieldName]:filterResponse.data});
			});*/
		}
		
	  }
	  

	 exportClick(event)
	{
	  	let postObj={};
	
	  	this.state.fields[0].fields.map((field)=> {
	  			
	  			if(this.state[`Filter_${field.fieldName}`]!=undefined && this.state[`Filter_${field.fieldName}`]!='' && field.isDummy===false)
	  			{
	  				 if(field.dataType==="lookup")
	  				 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
					 else if(field.dataType==="autocomplete")
						 postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
	  				 else if (field.dataType==="date")
	  				 {
	  				 	//alert(field.fieldName+' : '+this.state[`Filter_${field.fieldName}`]);
	  				 	let varSelectedDate=this.state[`Filter_${field.fieldName}`]
	  				 	let formattedDate=format(varSelectedDate, 'yyyy-MM-dd')
	  				 	//const formattedDate = varSelectedDate.getFullYear()+'-'+(varSelectedDate.getMonth()+1)+'-'
	  				 	//+varSelectedDate.getDate();
	  				 	//alert(formattedDate);
	  				 	postObj[field.fieldName]=formattedDate;
	  				 }
					   else if(field.dataType==="dropdown")
						{	  				 	
							postObj['cdnbool'+field.fieldName]=this.state[`Filter_${field.fieldName}`].toString();
						}
	  				 else
	  				 {
	  				 	
	  				 	postObj[field.fieldName]=this.state[`Filter_${field.fieldName}`];
	  				 }
	  			}

	  			}) 
	  		   
	  		    getDpExport(postObj)
					    .then((response) => {
					      if(response.data!=""){
					    	var win = window.open(response.data, '_blank');
  							win.focus();}
  							else
  								alert('Error exporting records')
					    })
	}

  render() {
  	//console.log("schedule::::",this.state.schedule);
    return (
      <>

      {

      	<div className="row">

          <div className="col-md-12">
            <CodeExample jsCode="true" beforeCodeTitle="Search Orders" csv ="true" exportClick={this.exportClick.bind(this)}>
              <div className="kt-section" >
              <Grid container spacing={3}>
      		  {
      			this.state.filter &&
		    	
		    	this.state.fields.map((screen) => (
		    		screen.fields.map((field)=>{
						
							if(field.dataType==='String')
							
							return(
								<Grid item xs={12} sm={6}>
									 <TextField  name={field.fieldName} label={field.displayName}
									 onChange={e=>this.setState({[`Filter_${field.fieldName}`]:e.target.value})}
									 />
						    	</Grid>
						    )
							 else if(field.dataType==='dropdown')
														
														return(
															<Grid item xs={12} sm={6}>
									
						    		 <TextField  style={{'width':'100%'}} name={field.fieldName}
									 select
									 label={field.displayName}
									 onChange={e=>this.setState({[`Filter_${field.fieldName}`]:e.target.value})}
									 >
									 {
										field.items.map((filter) => {
											return(
											<MenuItem key={filter.name} 
											value={filter.value}>
											{

												 
															filter.name
													
												
											}</MenuItem>)
										})
									
									}
									</TextField>
									
									</Grid>
														 )		
						    else if(field.dataType==='lookup' )
						    	return(
						    		<Grid item xs={12} sm={6}>
									 {field.lookUp.filterFieldName !==undefined && field.lookUp.filterFieldName!==null &&
						    		 <TextField   style={{'width':'100%'}} name={field.lookUp.lookupKey}
									 select
									 label={field.displayName}
									 onChange={e=>this.setState({[`Filter_${field.fieldName}`]:e.target.value})}
									 >
									 {
										this.state[field.fieldName].filter(x=>x[field.lookUp.filterFieldName]===this.state[`Filter_${field.lookUp.filterFieldName}`]).map((filter) => {
											return(
											<MenuItem key={filter[field.lookUp.lookupId]} 
											
											value={filter[field.lookUp.lookupId]}>

											{

												field.lookUp.lookupDisplay.split(/\s*,\s*/)
												.map((keyVal) => {
															return(<>{filter[keyVal]} </>);
													}
												)
											}</MenuItem>)
										})
									
									}
									</TextField>
									}
									{field.lookUp.filterFieldName ===undefined || field.lookUp.filterFieldName===null &&
						    		 <TextField   style={{'width':'100%'}} name={field.lookUp.lookupKey}
									 select
									 label={field.displayName}
									 onChange={e=>this.setState({[`Filter_${field.fieldName}`]:e.target.value})}
									 >
									 {
										this.state[field.fieldName].map((filter) => {
											return(
											<MenuItem key={filter[field.lookUp.lookupId]} 
											
											value={filter[field.lookUp.lookupId]}>

											{

												field.lookUp.lookupDisplay.split(/\s*,\s*/)
												.map((keyVal) => {
															return(<>{filter[keyVal]} </>);
													}
												)
											}</MenuItem>)
										})
									
									}
									</TextField>
									}
									</Grid>
						    )
							else if(field.dataType==='autocomplete')
						    	return(
						    		 <Grid item xs={12} sm={6}>
										 <Autocomplete
											id={field.lookUp.lookupKey}
											name={field.lookUp.lookupKey}
											value={this.state[`Filter_${field.fieldName}`]}
											options={this.state[field.fieldName]}
											autoComplete={true}
											clearOnBlur={true}
											getOptionLabel={(option) => option[field.lookUp.lookupDisplay]}
											onChange={(event,newValue)=>{this.autocompleteOnChange(event,newValue,`Filter_${field.fieldName}`,field.lookUp.lookupId);}}
											onInputChange={(event,value)=>{this.autocompleteOnInputChange(event,value,field.fieldName,field.lookUp.lookupId,field.lookUp.lookupName);}}						
											renderInput={(params) => <TextField {...params} label={field.displayName}/>}
										/>
						    		 </Grid>
						    )
						    else	 if(field.dataType==='date' )
							return(
								<Grid item xs={12} sm={6}>
									<MuiPickersUtilsProvider  utils={DateFnsUtils}>
		      
										        <KeyboardDatePicker
										          fullWidth
										          id="date"
										          label={field.displayName}
										          name = {field.fieldName}
										          format="MM/dd/yyyy"
										          value={this.state[`Filter_${field.fieldName}`]!=null ? this.state[`Filter_${field.fieldName}`] : null}
										          onChange={date =>this.setState({[`Filter_${field.fieldName}`]:date,selectedDate:date})}
										          KeyboardButtonProps={{
										            'aria-label': 'change date',
										          }}
										        />
										      
								    </MuiPickersUtilsProvider>
								
								</Grid>
															    
						    )
						   
						
		    			}) //{/* map  inner loop close*/}
		    		)) //{/* map loop close*/}
			}
			</Grid>
	    	</div>
		    	
		    	<div>
		    	<Button
				variant="outlined"
				color="primary"
				onClick={this.handleFilter.bind(this)}
				endIcon={<Icon>search</Icon>}
				style={{'padding':'10px','margin':'10px'}}
				>
				{
					this.state.isLoading==true&&<><Bounce /></>
				}
				{
					this.state.isLoading==false&&<>Apply Filter</>
				}
				</Button>
				
				<Button
				variant="outlined"
				color="primary"
				onClick={this.handleReset.bind(this)}
				endIcon={<Icon>backspace</Icon>}
				style={{'padding':'10px','margin':'10px'}}
				>
				{
					this.state.isReset==true&&<><Bounce /></>
				}
				{
					this.state.isReset==false&&<>Reset Filter</>
				}
				</Button>
 				</div>

            </CodeExample>
          	</div>
            </div>
		    }
		    <div className="kt-portlet">
				<div className="kt-portlet__body">
        			<div className="row">
		                {this.state.mStatus!=null && this.state.mStatus.map((status)=>(
		                  <div className="btn-toolbar kt-margin-l-20">
		                      <div className="dropdown" id="kt_subheader_group_actions_status_change">
		                      <button onClick={()=>this.filterByStatus(status.orderStatusId)} className="btn btn-success btn-elevate btn-pill btn-sm" style={{background: status.orderStatusColor, borderColor:status.orderStatusColor}}>
		                        {status.orderStatusName}
		                      </button></div>
		                  </div>
		                  ))}
		                  <div className="btn-toolbar kt-margin-l-20">
		                      <div className="dropdown" id="kt_subheader_group_actions_status_change">
		                      <button onClick={()=>this.filterByStatus(null)} className="btn btn-success btn-pill btn-sm" style={{background:'#2c3e50',borderColor:'#2c3e50'}} >
		                        Show All
		                      </button></div>
		                  </div>
		            </div>
		        </div>
            </div>
		
      	{	


      		this.state.schedules.map((sch)=> (
      		
      			<>
      		
      
       
			<div className="kt-portlet">

				<div className="kt-portlet__body">
					<div className="kt-widget kt-widget--user-profile-3">
						<div className="kt-widget__top">
											
												<div className="kt-widget__content">
													<div className="kt-widget__head">
														<p className="kt-widget__username" >
															
                  										<a href="#" style={{cursor:'pointer'}} onClick={()=>this.handleOpenStagedDrawer(sch)}>{'#'+sch.orderKey+' '}  </a>
                
															
															{/* sch.status == "green" && <i className="flaticon2-correct kt-font-success"></i>*/}
															{
															this.state.mStatus!=null &&
															(
															this.state.mStatus.filter(sts=> sts.orderStatusId==sch.orderStatusKey).map((fsts)=>(
																<Chip size={'small'} label={fsts.orderStatusName} style={{background:fsts.orderStatusColor,borderColor:fsts.orderStatusColor,color:'white'}} />
															))
															)
															
														}

														<Tooltip title="Update Status"><IconButton onClick={()=>this.setState({open:true,schedule:sch, tStatus: sch.status})} >
															<EditIcon style={{ color: '#5578eb',fontSize: 14
														}}/>  
														</IconButton>
														
														</Tooltip>

														</p>
													
														<div className="kt-widget__action">
															 { sch.invoiceStatus===false && this.state.permission.includes("CREATE:ORDERINVOICE") && 
															 <Tooltip title="Create Invoice"><a href='#' onClick={()=>this.handleOpenInvoiceDrawer(sch)} >
																<IconButton>
																	<DescriptionIcon style={{ color: '#5578eb',fontSize: 24
																	}}/>  
																</IconButton></a> 
															</Tooltip>}
															 { sch.invoiceStatus===true && this.state.permission.includes("VIEW:ORDERINVOICE") && 
															 <Tooltip title="View Invoice & Payment"><a href='#' onClick={()=>this.handleOpenInvoiceViewDrawer(sch)} >
																<IconButton>
																	<ReceiptIcon style={{ color: '#5578eb',fontSize: 24
																	}}/>  
																</IconButton></a> 
															</Tooltip>}
															{/* sch.invoiceStatus===true && sch.paidStatus ===false &&
																<Chip size={'small'} label={'Pending Approval'} style={{background:'red',borderColor:'red',color:'white'}} />
															*/}
														</div>
														
													</div>
													<div className="kt-widget__subhead">
														<Tooltip title="Payment Status"><a href='#' ><i className="flaticon2-tag"></i>{sch.paidStatus? "Paid" : "Not Paid"}</a></Tooltip>
														{/*<a href='www.smartch.com' ><i className="flaticon2-calendar-3"></i>{sch.startDate} </a>*/}
														
														<Tooltip title="Ordered By"><a href='#' ><i className="flaticon2-calendar-3"></i>
														{sch.accountName}
														
														
														</a></Tooltip>
														<Tooltip title="Order Date"><a href='#' ><i className="flaticon2-calendar-6"></i>{format(new Date(sch.createdOn), 'MM/dd/yyyy')} </a></Tooltip>
														<Tooltip title="Requested User"><a href='#' ><i className="flaticon2-user-1"></i>{sch.requestedBy} </a></Tooltip>
														<Tooltip title="Implant"><a href='#' ><i className="flaticon2-user-1"></i>{this.getImplantName(sch.implantTypeKey)} </a></Tooltip>
													</div>
													
												</div>
						</div>
					 
					</div>
					
			</div>
			</div>
		
		</>
		))}
	
		{this.state.schedule!=null &&
		<Dialog fullWidth={true}
        maxWidth={'xs'} open={this.state.open} onClose={this.handleCloseNew} aria-labelledby="form-dialog-title">
       
        <DialogTitle id="form-dialog-title">{'#'+this.state.schedule.orderKey}</DialogTitle>
        <DialogContent>
          <EditOrderReqStatus order={this.state.schedule} onUpdate={()=>this.updateStatus(this.state.schedule)} />
        </DialogContent>
      

        <DialogActions>
          <Button onClick={this.handleCloseNew} color="primary">
            Close
          </Button>
        
         
         
        </DialogActions>
         
      </Dialog>		
      }			
					
       
		{/*</InfiniteScroll>*/}
		{
			this.state.hasMoreItems &&
			<div style={{display:'flex', alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'}}>

        <Button
				variant="outlined"
				color="primary"
				onClick={this.loadMore.bind(this)}
				
				style={{'padding':'10px','margin':'10px'}}
				>
				{
					this.state.isLoading==true&&<><Bounce /></>
				}
				{
					this.state.isLoading==false&&<><SearchIcon style={{ color: '#5867dd',fontSize: 25}}/>  Load More</>
				}
				</Button>

			
		</div>
		}

		{/**invoice attributes drawer */}
		{this.state.selectedDrawerItem!=null &&
		<Drawer anchor={'right'} open={this.state.invoiceDrawerOpen} onClose={this.toggleInvoiceDrawer}>
			<EditOrderInvoice onUpdate={()=>this.updateItem(this.state.selectedDrawerItem)} onClose={()=>this.setState({invoiceDrawerOpen:false})} order={this.state.selectedDrawerItem} />
        </Drawer>
  		}

		
		{/**invoice drawer */}
		{this.state.selectedDrawerItem!=null && 
		<Drawer anchor={'right'} open={this.state.invoiceDrawerViewOpen} onClose={this.toggleInvoiceViewDrawer}>
			<OrderPayment onClose={()=>this.setState({invoiceDrawerViewOpen:false})} onPayment={()=>this.payment(this.state.selectedDrawerItem)} order={this.state.selectedDrawerItem}  permission={this.state.permission} />
        </Drawer>
  		}

		{/**invoice drawer */}
		{this.state.selectedDrawerItem!=null && 
		<Drawer anchor={'right'} open={this.state.stagedDrawerViewOpen} onClose={this.toggleStagedViewDrawer}>
			<StagedOrder onClose={()=>this.setState({stagedDrawerViewOpen:false})} order={this.state.selectedDrawerItem}  permission={this.state.permission} />
        </Drawer>
  		}
    
      </>
    );
  }
}
